import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './AdminLayout.css';

function AdminLayout({ children }) {
  const { t } = useTranslation();
  const location = useLocation();

  const NAV = [
    { path: '/admin', label: t('admin.dashboard') },
    { path: '/admin/users', label: t('admin.users') },
    { path: '/admin/ads', label: t('admin.ads') },
    { path: '/admin/verifications', label: t('admin.verifications') },
    { path: '/admin/reports', label: t('admin.reports') },
    { path: '/admin/categories', label: t('admin.categories') },
    { path: '/admin/newsletter', label: t('admin.newsletter') },
    { path: '/admin/analytics', label: t('admin.analytics') },
    { path: '/admin/languages', label: t('admin.languages') },
    { path: '/admin/token', label: t('admin.tokenSettings') },
  ];

  return (
    <div className="adminLayout">
      <aside className="adminSidebar">
        <h2 className="adminSidebarTitle">{t('admin.adminTitle')}</h2>
        <nav className="adminNav">
          {NAV.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`adminNavLink ${location.pathname === item.path ? 'active' : ''}`}
            >
              {item.label}
            </Link>
          ))}
        </nav>
        <Link to="/" className="adminBackLink">{t('admin.backToSite')}</Link>
      </aside>
      <main className="adminMain">{children}</main>
    </div>
  );
}

export default AdminLayout;
